import { Controller } from "@hotwired/stimulus"
// data-controller="vehicle-add"
export default class extends Controller {
  static targets = ["modal"]
  connect() { console.log("Vehicle Add Controller Connected"); }
  open() {
    console.log("Opening Add Vehicle Modal");
    if (this.hasModalTarget) {
      const d = this.modalTarget;
      (d.showModal ? d.showModal() : d.removeAttribute("hidden"))
    } else {
      console.error("No modal target found");
    }
  }
  close() { if (this.hasModalTarget) { const d = this.modalTarget; (d.close ? d.close() : d.setAttribute("hidden", "")) } }
}
